import React from 'react';
import moment from 'moment';
import { convertHtmlToText } from '@laigu/utils';

import EventIcon from './event-icon';
import style from './index.less';

const noContent = [4, 5];

const MessageClickQuickBtn = props => {
  const { data = {} } = props;
  const { action, content = {}, time, agentName } = data;
  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  const BtnMap = {
    1: '复制内容',
    2: '拨打电话',
    3: '跳转链接',
    4: '发送消息',
    5: '展示图片',
    6: '自助问答'
  };

  const text = noContent.includes(content?.type) ? '' : convertHtmlToText(content?.content);

  return (
    <div className={style['event-box']}>
      <ul className={style.header}>
        <li>
          <EventIcon action={action} />
        </li>
        <li className={style.date}>{date}</li>
        <li>{agentName}</li>
        <li>
          {'顾客'} {'点击按钮'} {`<${content?.btn_text}>`} {String(BtnMap[content?.type] ?? '')}
        </li>
      </ul>
      {text ? (
        <>
          {' '}
          <div className={style['event-border']} />
          <div className={style['evaluation-content']}>{text}</div>
        </>
      ) : null}
    </div>
  );
};

export default MessageClickQuickBtn;
